import { ChevronUpIcon, ChevronDownIcon } from 'app/agriculture/icons';
import classNames from 'classnames';
import './expand_icon.scss';

interface AgExpandIconButtonProps {
    expanded: boolean;
    onClick: () => void;
    size?: number;
    variant?: 'outlined' | 'default';
    inheritColor?: boolean;
}

export function AgExpandIconButton({
    size = 24,
    expanded,
    onClick,
    variant = 'default',
    inheritColor = false,
}: AgExpandIconButtonProps) {
    return (
        <button
            className={classNames([
                'AgExpandIconButton',
                `AgExpandIconButton--${variant}`,
                {
                    'AgExpandIconButton--expanded': expanded,
                    'AgExpandIconButton--inherit': inheritColor,
                },
            ])}
            data-testid={'ag-expand-button'}
            onClick={onClick}
        >
            <AgExpandIcon expanded={expanded} size={size} />
        </button>
    );
}

interface AgExpandIconProps {
    size?: number;
    expanded: boolean;
}

export function AgExpandIcon({ size = 24, expanded }: AgExpandIconProps) {
    return expanded ? <ChevronUpIcon size={size} /> : <ChevronDownIcon size={size} />;
}
